import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();
  const [showNewIn, setShowNewIn] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowNewIn(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleNewInClick = () => {
    navigate('/products?filter=new');
  };

  const handleShopNowClick = () => {
    navigate('/products');
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
      </div>
      
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-subtitle">
            <span className="subtitle-line"></span>
            Spring / Summer 2026
            <span className="subtitle-line"></span>
          </div>
          
          <h1 className="hero-title">
            <span className="title-line">A brand which </span>
            <span className="title-line gradient"> feels right to wear</span>
          </h1>

          <p className="hero-description">
            Explore curated collections from the world's most visionary designers. 
            Where artistry meets wardrobe.
          </p>

          <div className="hero-buttons">
            <button 
              className="hero-btn primary"
              onClick={handleShopNowClick}
            >
              SHOP NOW
              <FiArrowRight className="btn-icon" />
            </button>
            
            {showNewIn && (
              <button 
                className="hero-btn secondary"
                onClick={handleNewInClick}
              >
                NEW IN
                <FiArrowRight className="btn-icon" />
              </button>
            )}
          </div>

          {/* <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">200+</span>
              <span className="stat-label">Designers</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">50K+</span>
              <span className="stat-label">Happy Clients</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Authentic</span>
            </div>
          </div> */}
        </div>
      </div>

      <div className="hero-scroll">
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
        <span className="scroll-text">Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero;